const round = (x, n=2) => {
  if (Number.isNaN(x) || Number.isNaN(n)) return 0;
  const m = 10 ** n;
  return (Math.round(x * m) / m).toFixed(2);
};

export {round};



// WEBPACK FOOTER //
// ./src/app/utils/func.js